module.exports = __webpack_public_path__ + "img/coins-bg.2edc904f.png";